import React from "react";
import { ManageHeroBannersContent } from "../components/CMS/HeroBanners/ManageHeroBannersContent";
import { ToastContainer } from "react-toastify";

export const HeroBanners = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageHeroBannersContent />
        </div>
      </div>
    </div>
  );
};
